import React from 'react';

function ShopCardSkeleton() {
  return (
    <li className="shop-skeleton-card">
      <div className="skeleton-block shop-skeleton-card-visual" />
      <div className="shop-skeleton-card-footer">
        <div className="skeleton-lines">
          <div className="skeleton-block" style={{ height: 12, width: '80%' }} />
          <div className="skeleton-block" style={{ height: 10, width: '45%' }} />
        </div>
        <div className="skeleton-block" style={{ height: 32, width: '100%' }} />
      </div>
    </li>
  );
}

function ShopSectionSkeleton({ cardCount = 4 }) {
  return (
    <section className="shop-skeleton-section">
      <div className="shop-skeleton-section-header">
        <div className="skeleton-row" style={{ gap: 10 }}>
          <div className="skeleton-circle" style={{ width: 28, height: 28 }} />
          <div className="skeleton-block" style={{ height: 20, width: 120 }} />
        </div>
        <div className="skeleton-block" style={{ height: 14, width: 72 }} />
      </div>
      <ul className="shop-skeleton-row">
        {Array.from({ length: cardCount }, (_, index) => (
          <ShopCardSkeleton key={index} />
        ))}
      </ul>
    </section>
  );
}

export default function ShopSkeleton() {
  return (
    <div className="page-skeleton shop-skeleton">
      <ShopSectionSkeleton cardCount={4} />
      <ShopSectionSkeleton cardCount={4} />
      <ShopSectionSkeleton cardCount={3} />
    </div>
  );
}
